<template>
  <div>
    <div
      class="card"
      @mouseover="hovered = true"
      @mouseleave="hovered = false"
      :class="{
        focused: hovered && !isLight && !disableBorders,
        light: isLight,
        active: active && !disableBorders,
        '--has-sublabel': !!subLabel
      }"
      v-on="$listeners"
    >
      <div class="leading-icon">
        <DragHandle
          v-if="isDraggable"
          class="drag-handle-selectable"
          ref="dragHandle"
          @click="$emit('dragHandleClick')"
          :hidden="hideDragHandle"
        />
        <n-icon @click="$emit('leadingIconClick')" v-else-if="leadingIcon" :icon="leadingIcon" size="s" />
      </div>
      <div class="text-section">
        <div class="text">
          <span class="label">
            {{ label }}
          </span>
          <span v-if="subLabel" class="sub-label">
            {{ subLabel }}
          </span>
        </div>

        <div class="trailing-icon">
          <n-icon :icon="trailingIcon" size="s" />
        </div>
      </div>
      <div class="action">
        <slot name="action"></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import DragHandle from '@/modules/global/components/DragHandle.vue'

@Component({
  components: {
    DragHandle
  }
})
export default class NSelectableCard extends Vue {
  @Prop() leadingIcon!: string
  @Prop() trailingIcon!: string
  @Prop({ default: false }) isDraggable!: boolean
  @Prop({ default: false }) hideDragHandle!: boolean
  @Prop() label!: string
  @Prop() subLabel!: string
  @Prop() active!: boolean
  @Prop({ default: false }) isLight!: boolean
  @Prop({ default: false }) disableBorders!: boolean

  hovered = false
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.card {
  display: flex;
  z-index: $notch-layer-1;
  align-items: center;
  padding: $notch-space-4x;
  margin-bottom: $notch-space-2x;
  scroll-margin: $notch-space-2x;
  cursor: pointer;

  background: $notch-color-neutral-sand-50;
  border-radius: $notch-radius-2x;

  color: $notch-color-neutral-grey-900;

  &.--has-sublabel {
    align-items: unset;
  }
  .text-section {
    margin-right: auto;
    display: flex;
    .text {
      display: flex;
      flex-direction: column;
      .label {
        @include notch-text-label-strong-M;
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .sub-label {
        @include notch-text-label-light-S;
        margin-top: $notch-space-2x;
        color: $notch-color-neutral-sand-600;
      }
    }
  }

  .leading-icon,
  .label {
    margin-right: $notch-space-2x;
  }

  .trailing-icon {
    color: $notch-color-neutral-sand-600;
  }

  &.light {
    background: $notch-color-neutral-grey-000;
    color: $notch-color-neutral-grey-600;
  }

  &.focused,
  &.active {
    @include notch-style-focus;
  }
}
</style>
